import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { allowedTagsDefault } from '@Services/HtmlSanitizeService';

function LoginEnforcedNotification({ notifications }) {
  if (!notifications) {
    return null;
  }
  return (
    <div className="login-page-left-notification">
      {notifications.CUSTOM_LEFT &&
        notifications.CUSTOM_LEFT.map((notification) => (
          <div key={`left-notification-${notification}`} className="notification-container">
            <div className="notification--info rx-border-none">
              <div className="notification--icon">i</div>
              <InnerHTML
                tag="div"
                className="notification--content"
                html={notification}
                mode="escape"
                allowedTags={allowedTagsDefault.concat('a')}
                allowedAttributes={['href', 'target']}
              />
            </div>
          </div>
        ))}
      {notifications.ENFORCED_LOGIN_MESSAGE && (
        <div className="notification-container">
          <InnerHTML
            tag="div"
            className="notification-container--message"
            html={notifications.ENFORCED_LOGIN_MESSAGE}
            mode="escape"
            allowedTags={allowedTagsDefault.concat('a')}
            allowedAttributes={['href', 'target']}
          />
        </div>
      )}
    </div>
  );
}

LoginEnforcedNotification.propTypes = {
  notifications: PropTypes.object,
};

export default LoginEnforcedNotification;
